import React from 'react';
import {Spinner} from 'reactstrap';

const MobileLoadingScreen = () => {
    return (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <Spinner style={{ width: '50px', height: '50px', borderWidth: '5px', position: 'relative', top: '-4rem' }} />
        </div>
    );
};

export default MobileLoadingScreen;
